import React, { useEffect, useState } from "react";
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import Modal from '@/components/Modal/Modal.jsx';

const dps = [
    // 第1行
    {
        name: '业务流程',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BfList',
        bizNodeType: 'BF',
        count: 0,
        addCount: 0,
    },
    {
        name: '程序模块',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdList',
        bizNodeType: 'BD',
        count: 0,
        addCount: 0,
    },
    // {
    //     name: '业务服务',
    //     color: 'rgb(255, 255, 153)',
    //     redirectUrl: 'SvrList',
    //     bizNodeType: 'SVR',
    //     count: 0,
    //     addCount: 0,
    // },
    {
        name: '数据对象',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdRuleList',
        bizNodeType: 'IS',
        count: 0,
        addCount: 0,
    },
    {
        name: '数据实体',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdRuleList',
        bizNodeType: 'DE',
        count: 0,
        addCount: 0,
    },
    {
        name: '业务规则',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdRuleList',
        bizNodeType: 'BDRULE',
        count: 0,
        addCount: 0,
    },

    // 第2行
    {
        name: '用户场景',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdSummaryList',
        bizNodeType: 'BDSUMMARY',
        count: 0,
        addCount: 0,
    },
    {
        name: '交互程序能力',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdLogicList',
        bizNodeType: 'BT',
        count: 0,
        addCount: 0,
    },
    {
        name: '接口程序能力',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdLogicList',
        bizNodeType: 'INF',
        count: 0,
        addCount: 0,
    },
    {
        name: '自动程序能力',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdLogicList',
        bizNodeType: 'TIME',
        count: 0,
        addCount: 0,
    },
    {
        name: '基础程序能力',
        color: 'rgb(255, 255, 153)',
        redirectUrl: 'BdLogicList',
        bizNodeType: 'BL',
        count: 0,
        addCount: 0,
    },

    // {
    //     name: '业务事件',
    //     color: 'rgb(255, 255, 153)',
    //     redirectUrl: 'BdEventList',
    //     bizNodeType: 'BDEVENT',
    //     count: 0,
    //     addCount: 0,
    // },
    // {
    //     name: '定时功能',
    //     color: 'rgb(253, 216, 52)',
    //     redirectUrl: 'SfList',
    //     bizNodeType: 'TIME_SF',
    //     count: 0,
    //     addCount: 0,
    // },
    // {
    //     name: '接口功能',
    //     color: 'rgb(253, 216, 52)',
    //     redirectUrl: 'SfList',
    //     bizNodeType: 'INF_SF',
    //     count: 0,
    //     addCount: 0,
    // },
    //
    // // 第3行
    // {
    //     name: '交互功能',
    //     color: 'rgb(253, 216, 52)',
    //     redirectUrl: 'SfList',
    //     bizNodeType: 'UI_SF',
    //     count: 0,
    //     addCount: 0,
    // },
    {
        name: '用户界面',
        color: 'rgb(80, 195, 247)',
        redirectUrl: 'UiList',
        bizNodeType: 'UI',
        count: 0,
        addCount: 0,
    },
    {
        name: '界面视图',
        color: 'rgb(80, 195, 247)',
        redirectUrl: 'UvList',
        bizNodeType: 'UV',
        count: 0,
        addCount: 0,
    },
    {
        name: '界面规则',
        color: 'rgb(80, 195, 247)',
        redirectUrl: 'UiRuleList',
        bizNodeType: 'UIRULE',
        count: 0,
        addCount: 0,
    },
    {
        name: '界面事件能力',
        color: 'rgb(80, 195, 247)',
        redirectUrl: 'UeList',
        bizNodeType: 'UE',
        count: 0,
        addCount: 0,
    },

    {
        name: '界面基础能力',
        color: 'rgb(80, 195, 247)',
        redirectUrl: 'UiAlgList',
        bizNodeType: 'UIALG',
        count: 0,
        addCount: 0,
    },

    // 第4行
    {
        name: '外联系统',
        color: 'rgb(186, 105, 200,0.75)',
        redirectUrl: 'LsList',
        bizNodeType: 'LS',
        count: 0,
        addCount: 0,
    },
    {
        name: '外联接口',
        color: 'rgb(186, 105, 200,0.75)',
        redirectUrl: 'LsiList',
        bizNodeType: 'LSI',
        count: 0,
        addCount: 0,
    },
    {
        name: '数据库',
        color: 'rgb(125, 255, 255)',
        redirectUrl: 'DbList',
        bizNodeType: 'DB',
        count: 0,
        addCount: 0,
    },
    {
        name: '数据表',
        color: 'rgb(125, 255, 255)',
        redirectUrl: 'DtList',
        bizNodeType: 'DT',
        count: 0,
        addCount: 0,
    },
    {
        name: '表字段',
        color: 'rgb(125, 255, 255)',
        redirectUrl: 'DfList',
        bizNodeType: 'DF',
        count: 0,
        addCount: 0,
    },

    // 第5行
    {
        name: '数据视图',
        color: 'rgb(125, 255, 255)',
        redirectUrl: 'DvList',
        bizNodeType: 'DV',
        count: 0,
        addCount: 0,
    },
    {
        name: 'CDT',
        color: 'rgb(125, 255, 255)',
        redirectUrl: 'CdtList',
        bizNodeType: 'CDT',
        count: 0,
        addCount: 0,
    },
    {
        name: '标准字段组',
        color: 'rgb(125, 255, 255)',
        redirectUrl: 'DmPcdgList',
        bizNodeType: 'CDG',
        count: 0,
        addCount: 0,
    },
    {
        name: '子系统',
        color: 'rgb(213, 251, 97)',
        redirectUrl: 'SsList',
        bizNodeType: 'SS',
        count: 0,
        addCount: 0,
    },
    {
        name: '中间件',
        color: 'rgb(213, 251, 97)',
        redirectUrl: 'ArchMiddlewareList',
        bizNodeType: 'MID',
        count: 0,
        addCount: 0,
    },

    // 第6行
    {
        name: '数据库实例',
        color: 'green',
        bizNodeType: 'DBINS',
        count: 0,
        addCount: 0,
    },
    {
        name: '子系统实例',
        color: 'green',
        bizNodeType: 'SSINS',
        count: 0,
        addCount: 0,
    },
    {
        name: '中间件实例',
        color: 'green',
        bizNodeType: 'MIDINS',
        count: 0,
        addCount: 0,
    },
]

const GridBlock = ({ name, color, redirectUrl, count, addCount }) => {
    const styleGridBlock = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        containerType: 'size',
        padding: 12,
        // gap: 4,
        backgroundColor: `${color ?? '#f0f0f0'}`,
        // border: `1px solid ${color ?? '#f0f0f0'}`,
        borderRadius: 4,
    }

    const styleGridBlockTitle = {
        display: 'flex',
        alignItems: 'center',
        // fontSize: 12,
        color: 'black',
    }

    const styleGridBlockCount = {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        fontSize: 12,//12
        fontWeight: 'bold',
        // cursor: 'pointer',
    }

    return (
        <div style={styleGridBlock}>
            <div style={styleGridBlockTitle}>
                {name}
            </div>

            <div style={styleGridBlockCount}>
                <div title="模件数量">{count}</div>
            </div>
        </div>
    );
}

const Dlg = ({ prjId, sVer, onOk, ...props }) => {
    const http = useHTTP();
    const [boards, setBoards] = useState([]);

    useEffect(() => {
        init();
    }, [prjId, sVer]);

    const init = async () => {
        try {
            const data = await runAsync(
                async () => {
                    return await http.get(`/dps/statis`, { prjId, sVer });
                }, {
                error: { content: (err) => `查询失败: ${err.message}` },
                loading: { show: true },
                success: { show: false },
            });

            for (const dp of dps) {
                dp.count = data[dp.bizNodeType];
            }

            setBoards([...dps]);
        } catch (err) {
            console.log(err);
        }
    }

    const styleGrid = {
        flexGrow: '1',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr',
        gap: 12,
        height: '400px',
    }

    return (
        <Modal
            title={"模件看板"}
            width={800}
            style={{ top: 20 }}
            bodyStyle={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '80vh', minHeight: 320, background: '#fff', padding: 12 }}
            closable={true}
            footer={null}
            {...props}
        >
            <div style={styleGrid}>
                {
                    boards.map(item => <GridBlock {...item} />)
                }
            </div>
        </Modal>
    );
}

export default Dlg;
